export const getSafeAculLink = (href?: string | null): string | null => {
  if (!href) {
    return null;
  }

  const normalizedHref = href.trim();
  if (!normalizedHref) {
    return null;
  }

  const invalidValues = new Set(["none", "null", "undefined", "#"]);
  if (invalidValues.has(normalizedHref.toLowerCase())) {
    return null;
  }

  if (/^javascript:/i.test(normalizedHref)) {
    return null;
  }

  return normalizedHref;
};
